import { createIcon } from "@chakra-ui/react";
import * as React from "react";

export const ShrtnrIcon = createIcon({
  displayName: "ShrtnrIcon",
  viewBox: "0 0 500 500",
  path: [
    <path
      key={1}
      d="M0 275 l0 -155 50 0 50 0 0 155 0 155 -50 0 -50 0 0 -155z"
      fill="currentColor"
    />,
    <path
      key={2}
      d="M120 380 l0 -50 155 0 155 0 0 50 0 50 -155 0 -155 0 0 -50z"
      fill="currentColor"
    />,
    <path
      key={3}
      d="M330 155 l0 -155 50 0 50 0 0 155 0 155 -50 0 -50 0 0 -155z"
      fill="currentColor"
    />,
    <path
      key={4}
      d="M0 50 l0 -50 155 0 155 0 0 50 0 50 -155 0 -155 0 0 -50z"
      fill="currentColor"
    />,
  ],
});
